import type { AccentHue } from "@repo/fika-design-system/color"
import type { IconName } from "@repo/fika-design-system/icon"
import type { ParentProps } from "solid-js"
import { Box } from "@/designSystem/components/box"
import { Button } from "@/designSystem/components/button"
import { Section } from "@/designSystem/patterns/section"
import { Well } from "./well"

type SaveButtonProps = {
  disabled?: boolean
  hue: AccentHue
  iconName: IconName
  label?: string
}
function Save(props: SaveButtonProps) {
  return (
    <Box justifyContent="flex-end" flexDirection="row" gap="8">
      <Button
        hue={props.hue}
        iconName={props.iconName}
        type="submit"
        disabled={props.disabled}
      >
        {props.label || "save"}
      </Button>
    </Box>
  )
}

type Props = {
  title: string
  description: string
  hue: AccentHue
  iconName: IconName
  onSubmit?: () => void
} & ParentProps
export function Form(props: Props) {
  return (
    <Section
      title={props.title}
      description={props.description}
      hue={props.hue}
      iconName={props.iconName}
    >
      <form
        onSubmit={e => {
          e.preventDefault()
          e.stopPropagation()
          props.onSubmit?.()
        }}
      >
        <Well>{props.children}</Well>
      </form>
    </Section>
  )
}

Form.Save = Save
